export const CLOCKS_PER_PAGE = 3
